import { Link } from 'react-router-dom';
import { PageSection } from '../components/page_section';
import { StatusPanel } from '../components/status_panel';

export function NotFoundPage() {
  return (
    <PageSection className="app-gradient min-h-[calc(100dvh-3.5rem)] py-20">
      <StatusPanel
        title="Page not found"
        action={
          <Link to="/" className="font-black text-aws-blue underline underline-offset-4">
            Return to athlete lookup
          </Link>
        }
      >
        The page you requested does not exist.
      </StatusPanel>
    </PageSection>
  );
}
